import {initializeApp} from "firebase/app";
import {getFirestore} from "firebase/firestore";
import {getStorage} from "firebase/storage";
import {getAuth} from "firebase/auth";

const firebaseConfig = {
    apiKey: "AIzaSyDUa7VtjI6d2owxnp1IwK0AT8iGN5JNHNU",
    authDomain: "community-connect-5e6a2.firebaseapp.com",
    projectId: "community-connect-5e6a2",
    storageBucket: "community-connect-5e6a2.appspot.com",
    messagingSenderId: "283583274256",
    appId: "1:283583274256:web:59237e00a9a0f7d05d9995"
  };
  

  const app = initializeApp(firebaseConfig);
  const auth = getAuth(app)
  const db = getFirestore(app);
  const storage = getStorage(app);

  export { auth, db, storage};